export default "__VITE_ASSET__c1faf8db__"